import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Card } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import postRideGif from '../driver-vector-happy-5.gif'
import postRequestSvg from '../driving-clipart-auto-insurance-589723-4633234.svg'



class PostRequestChoose extends Component {
 
  render() {
    return (
        <div>
            
            {/* <Header style={{backgroundColor: '#ffffff', height: '66px'}}>
                <Row>
                    <Col span={8}>
                        <Link to="/">
                            <span style={{color: '#fa541c', fontSize: '3em', fontWeight: 'bolder'}}>Safari</span>
                        </Link>
                    </Col>
                </Row>
            </Header> */}
            <div style={{ background: '#ffffff', padding: 50, minHeight: 280 }}>
                <Row gutter={24}>
                    <Col md={{span: 8, offset: 2}} sm={24}>
                        <Card style={{textAlign: 'center'}}>
                            <h2 style={{color: "#ff3d00", margin: "12px", textAlign: 'center'}}>You need a ride?</h2> 
                            <br/>
                            <img src={postRequestSvg}  className="Driver-gif" alt="logo" />
                            <br/>
                            <br/>
                            <Link to="/post-request">
                                <Button type="primary" shape="round"  size='large' icon="plus" style={{backgroundColor: '#ff3d00', borderWidth: '0px'}}>Post a request</Button>
                            </Link>
                        </Card>
                    </Col>

                    <Col  md={{span: 8, offset:4}} sm={24}>
                        <Card style={{textAlign: 'center'}}>
                            <h2 style={{color: "#00abff", margin: "12px", textAlign: 'center'}}>You have seats?</h2> 
                            <br/>
                            <img src={postRideGif}  className="Driver-gif" alt="logo" />
                            <br/>
                            <Link to="/post-trip">
                                <Button type="primary" shape="round"  size='large' icon="plus">Post a ride</Button>
                            </Link>
                        </Card>
                    </Col>
                    
                </Row>  
            </div> 
        </div>
    );
  }
}

export default PostRequestChoose;

